module.exports = __webpack_public_path__ + "img/tarjeta.7a052162.svg";